export const TransferOfChargeConstant = {
    CATEGORY: "Counter Charge",
    TITLE: "Transfer Of Charge Details",
    BULK_EDIT: "Bulk Edit",
    SEARCH_CRITERIA: "Search Criteria",
    OPS_DATE_RANGE: 'Ops Date Range',
    CO_VSL_VOY: 'Co/Vsl/Voy',
    STATE: "State",
    SEQ_NO: "Seq. No.",
    CHARGEON_COMPANY: "Charge-On Company",
    BILLTO_COMPANY: "Bill-To Company",
    CONSORTIUM_CODE: "Consortium Code",
    VESSEL_CODE: "Vessel Code",
    VOYAGE_CODE: "Voyage Code",
    ETD: "ETD",
    CHARGE_TYPE: "Charge Type",
    SUB_CHARGE_TYPE: "Sub Charge Type",
    CONTAINER_NO: "Container No.",
    CONTAINER_NO_VEHICLE_NO: "Container No./Vehicle No.",
    STATUS: "Status",
    SIZE: "Size",
    TYPE: "Type",
    SERVICE_ORDER_CODE: "Service Order Code",
    TARIFF_TYPE: "Tariff Type",
    TARIFF_CODE: "Tariff Code",
    QTY: "Qty",
    UOM: "UOM",
    OPS_LINE: "Ops Line",
    CNIC_NO: "CNIC No.",
    VEHICLE_NO: "Vehicle No.",
    DAMAGE_TYPE: "Damage Type",
    AMOUNT: "Amount",
    REMARKS: "Remarks",
    COMMODITY_CODE: "Commodity Code",
    SHIPPER__CONSIGNEE: "Shipper / Consignee",
    DRAFT_INVOICE_NO: "Draft Invoice No.",
    FINAL_INVOICE_NO: "Final Invoice No.",
    DRAFT_CREDIT_NOTE_NO: "Draft Credit Note No.",
    FINAL_CREDIT_NOTE_NO: "Final Credit Note No.",
    ADJ_TYPE: "Adj. Type",
    MANUAL_CHARGE_NO: "Manual Charge No.",
    CREDIT_CHARGE_NO: "Credit Charge No.",
    CONTAINER_TYPE_GROUP: "Container Type Group",
    OPS_DATE: "Ops Date",
    BILL_OF_LADING__REF_NO: "Bill of Lading / Ref. No.",
    BILL_OF_LADING: "Bill of Lading",
    SHIPPING_BILL: "Shipping Bill",
    SERVICE_CODE: "Service Code",
    AGENT_NO: "Agent No.",
    AGENT_NAME: "Agent Name",
    PAID_THROUGH_DATE: "Paid Through Date",
    OPERATING_TML: "Operating Tml",
    CHANGE_DATETIME: "Change Date/Time",
    RELEASE_DATETIME: "Release Date/Time",
    ONEOFF_RATE: "One-Off Rate",
    SPECIAL_IND: "Special Ind.",
    VESSEL_NAME: "Vessel Name",
    ORI_OWNER: "Ori Owner",
    ORI_STATUS: "Ori Status",
    NEW_OWNER: "New Owner",
    NEW_STATUS: "New Status",
    CHARGE_CODE: "Charge Code",
    TELEX_NO: "Telex no",
    CHARGE_IND: "Charge Ind",
    SHIPMENT_TYPE: "Shipment Type",
    FORWARDER_REF: "Forwarder Ref",
    BARGE_JOB_ID: "Barge Job ID",
    ARR_DATETIME: "Arr Date/Time",
    OTHER_ARR_DATETIME: "Other Arr Date/Time",
    OTHER_DEP_DATETIME: "Other Dep Date/Time",
    OTHER_SERVICE: "Other Service",
    POD2: "POD2",
    POD_GEOG_IND: "POD Geog Ind",
    REQUEST_DATETIME: "Request Date/Time",
    REASON_CODE: "Reason Code",
    RECEIVE_DATETIME: "Receive Date/Time",
    LOADING_DATE_TIME: "Loading Date Time",
    FIRST_LOADING_DATETIME: "First Loading Date/Time",
    LAST_LOADING_DATETIME: "Last Loading Date/Time",
    CHARGING_FROM_DATETIME: "Charging From Date/Time",
    CHARGING_TO_DATETIME: "Charging To Date/Time",
    RECEVAL_CUTOFF_TIME: "Receval Cutoff Time",
    ST_TIER_FSP: "1st Tier Fsp",
    ND_TIER_FSP: "2nd Tier Fsp",
    CHARGING_QTY_ADJUST: "Charging Qty Adjust",
    CALENDAR_ADJUST_CHARGE_QTY: "Calendar Adjust Charge Qty",
    MANUAL_ADJUST_CHARGE_QTY: "Manual Adjust Charge Qty",
    MANUAL_ADJUST_UOM: "Manual Adjust UOM",
    DG_CONTENT: "DG Content",
    DU_CONTENT: "DU Content",
    PERMIT_NO: "Permit no",
    RF_TEMP: "RF Temp.",
    RF_TEMP_UNIT: "Rf Temp. Unit",
    DIRECTINDIRECT_DISCHARGE_IND: "Direct/Indirect Discharge Ind.",
    SO_NUMBER: "So Number",
    TRAIN_ID: "Train ID",
    TRACTOR_NO: "Tractor No",
    FD_GEOG_IND: "FD Geog Ind.",
    WAIVER_NO: "Waiver No",
    POO_GEOG_IND: "POO Geog Ind.",
    POL_GEOG_IND: "POL Geog Ind.",
    EQUIPMENT_CODE_IND: "Equipment Code Ind.",
    EQUIPMENT_CODE: "Equipment Code",
    NO_OF_STORAGE: "No. Of Storage",
    DISCHARGE_DATETIME: "Discharge Date/Time",
    FIRST_DISCHARGE_DATETIME: "First Discharge Date/Time",
    LAST_DISCHARGE_DATETIME: "Last Discharge Date/Time",
    EXPIRY_DATETIME: "Expiry Date/Time",
    DELIVERY_DATETIME: "Delivery Date/Time",
    ATB_DATETIME: "ATB Date/Time",
    CASH_OT_DAYS: "Cash OT Days",
    CASH_AMOUNT: "Cash Amount",
    CASH_RECEIPT_NO: "Cash Receipt No.",
    IMCO_CODE: "IMCO Code",
    SPECIAL_CODE: "Special Code",
    SPECIAL_HANDLING_IND: "Special Handling Ind.",
    POO: "POO",
    POL: "POL",
    POD: "POD",
    FD: "FD",
    POO_COUNTRY: "POO Country",
    POL_COUNTRY: "POL Country",
    POD_COUNTRY: "POD Country",
    FD_COUNTRY: "FD Country",
    EXCESS_WEIGHT: "Excess Weight",
    GROSS_WEIGHT: "Gross Weight",
    MAX_GROSS_WEIGHT: "Max Gross Weight",
    CARGO_CODE: "Cargo Code",
    WAIVER_REASON_CODE: "Waiver Reason Code",
    WAIVER_REJECT_REASON: "Waiver Reject Reason",
    WAIVER_APPROVED_BY: "Waiver Approved By",
    WAIVER_APPROVED_DATE: "Waiver Approved Date",
    EXCISE_CASH_NO: "Excise Cash No.",
    LIFT_ONOFF_IND: "Lift On/Off Ind.",
    NO_OF_WAIVED_DAYS: "No. of Waived Days",
    SERVICE_REQUEST_REF: "Service Request Ref.",
    SERVICE_REQUEST_CODE: "Service Request Code",
    SUBSERVICE_REQUEST_CODE: "Sub-Service Request Code",
    EXCEPTION_MSG: "Exception Msg",
    LOCATION_TYPE: "Location Type",
    CNTR_NO_REF: "Cntr No. Ref",
}
